import AmioHttpService from '@/services/amio/amio-http.service'

class IndexExecutionsService extends AmioHttpService {
  async create(indexId) {
    try {
      const response = await this.requestPost(`/indexes/${indexId}/executions`)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

}

export default new IndexExecutionsService()
